import { render } from "./prescriptionDeptGoodsPayment.vue?vue&type=template&id=f4315546&scoped=true"
import script from "./prescriptionDeptGoodsPayment.vue?vue&type=script&lang=js"
export * from "./prescriptionDeptGoodsPayment.vue?vue&type=script&lang=js"

import "./prescriptionDeptGoodsPayment.vue?vue&type=style&index=0&id=f4315546&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4315546"]])

export default __exports__